import {Button, IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import React, {useContext} from 'react';
import Modal from './Modal';
import './IntroModal.scss';
import {StateContext} from '../App';
import twoFingers from '../images/two-fingers.png';
import oneFinger from '../images/one-finger.png';
import {observer} from 'mobx-react';

const IntroModal = observer(({onClose, level}) => {
    const stateContext = useContext(StateContext);
    const {isTouchDevice} = stateContext;

    return (
        <Modal className="intro-modal">
            <IconButton aria-label="close" onClick={onClose} className="close-btn">
                <Close />
            </IconButton>
            <div className="header">
                <h1>Syrch</h1>
                <div>is</div>
                <h3>A Word Search Game</h3>
            </div>
            <hr></hr>
            <div className="content">
                <div>
                    <h4>How do I play?</h4>
                    <div className="instructions">
                        <TimerOutlinedIcon className="picto" />
                        <p>This is a time based game with levels</p>
                    </div>
                    {isTouchDevice ? (
                        <>
                            <div className="instructions">
                                <p>Scroll around the letters board to search for words</p>
                            </div>
                            <div className="instructions">
                                <p>Use a long tap & drag to start collecting letters</p>
                            </div>
                            {/* <div className="instructions">
                                <img src={twoFingers} alt="two fingers scrolling" width="50px" />
                                <p>
                                    Tap with 2 fingers to <b>toggle</b> the letters board scrolling
                                </p>
                            </div> */}
                        </>
                    ) : (
                        <p className="instructions">
                            Click-and-drag to collect letters<br></br>
                            <br></br>
                            Release the mouse to check the word you found
                        </p>
                    )}
                </div>

                <Button className="play-btn" variant="contained" onClick={onClose}>
                    Play Level {stateContext.level}
                </Button>
            </div>

            <span className="copyrights">
                <a href="https://twitter.com/mattibarzeev" target="_blank" rel="noopener noreferrer">
                    Matti Bar-Zeev
                </a>
                , 2022
            </span>
            <p></p>
        </Modal>
    );
});

export default IntroModal;
